/**
 * Multi-tier progress tracker (snippets/gift-with-purchase-tracker.liquid),
 * used identically in the push-cart drawer and the PDP block. Clicking a
 * tier's info icon swaps the quick-buy drawer to an image gallery and
 * truncated product info view.
 */
class GiftWithPurchaseTracker extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.querySelectorAll('[data-gift-with-purchase-el="tier_info"]').forEach(button => {
      this.listeners.add(button, 'click', () => this.handleInfoClick(button))
    })
  }

  handleInfoClick (button) {
    const drawer = document.querySelector('drawer-gift-with-purchase')
    if (!drawer) {
      console.warn('GWP: No drawer-gift-with-purchase element found')
      return
    }

    drawer.openGalleryView({
      productUrl: button.dataset.productUrl,
      rewardTitle: button.dataset.rewardTitle,
      rewardText: button.dataset.rewardText,
    })
  }
}

if (!customElements.get('gift-with-purchase-tracker')) {
  customElements.define('gift-with-purchase-tracker', GiftWithPurchaseTracker)
}
